<div class="modal-dialog" role="document">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal" type="button" (click)="resetUrl();">Chiudi</button>
		</p>
		
	</div>
</div>